import React from 'react'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import { FormattedMessage } from 'react-intl'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles'

const useStyles = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            switchLabelStyle: {
                marginBottom: 10
            }
        }
    )
)

interface AcceptingProps {
    label: string,
    value: any,
    onChange: (value: boolean) => void
}

type SwitchFieldProps = AcceptingProps

const SwitchField: React.FC<SwitchFieldProps> = (
    {
        label,
        value,
        onChange
    }
) => {
    const classes = useStyles()
    const labelClass: ClassValue = classNames(
        classes.text5,
        classes.colorBlue,
        classes.switchLabelStyle
    )

    return (<>
            <div className={labelClass}>
                {label}
            </div>
            <FormGroup row>
                <FormControlLabel
                    control={
                        <Switch
                            checked={value}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.checked)}
                            color="primary"
                        />
                    }
                    label={<span className={classes.text1}>
                        <FormattedMessage
                            id={`global.switch.${value ? 'enabled' : 'disabled'}`}
                            defaultMessage={value ? 'Activé' : 'Désactivé'}
                            description="Swich label"
                        />
                    </span>
                    }
                />
            </FormGroup>
        </>
    )
}

export default SwitchField
